import React from "react";
import Menu from "../Componet/Menu";
import UserNavbar from "../Componet/UserNavbar";
import Footer from "../Componet/Footer";

function UMenu() {
  return (
    <div>
      <div className="navbar23">
      <UserNavbar />
      </div>
    
   
      <Menu />
      
      <Footer />
    </div>
  );
}

export default UMenu;
